// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { IconProps } from "@insite/mobius/Icon";
import { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { color, xScreen } from "@rc/XDL/Utilities";
import { css } from "styled-components";

export interface fixedQuickOrderStyles {
    container: InjectableCss;
    trigger: InjectableCss;
    triggerLabel: TypographyProps;
    closeIcon: IconProps;
    triggerIcon: IconProps;
    panel: InjectableCss;
}

export const fixedQuickOrderStyles: fixedQuickOrderStyles = {
    container: {
        css: css`
            &&&& {
                .compact-quick-order-container {
                    min-height: 200px;
                    margin-top: 0;
                }
            }
        `,
    },
    trigger: {
        css: css`
            position: fixed;
            left: -105px;
            top: 20%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
            padding: 4px 12px;
            background: ${color("primary")};
            border-radius: 0 5px 5px 0;
            transition: all 300ms cubic-bezier(0, 0, 0.58, 1);
            ${xScreen("lte", "sm")}{
                left: -136px;
                padding-right: 5px;
                &:hover {
                    padding-right: 10px;
                }
                svg {
                    transform: scaleX(-1);
                }
            }
            &:hover {
                left: 0;
            }

            ${({ isFixedQuickOrderOpened }: any) => {
                if (isFixedQuickOrderOpened) {
                    return `
                        left: 0 !important;
                        padding-right: 10px !important;
                    `;
                }
            }}

            ${({ navDrawerIsOpen }: any) => {
                if (navDrawerIsOpen) {
                    return `
                        display: none;
                    `;
                }
            }}
        `,
    },
    triggerLabel: {
        color: "common.ui1",
        weight: 500,
        size: 16,
        css: css`
            margin-left: 5px;
            margin-right: 10px;
        `,
    },
    closeIcon: {
        src: "Close",
        color: "common.ui1",
        size: 15,
        css: css`
            position: relative;
            right: -5px;
        `,
    },
    triggerIcon: {
        src: "RowsActive",
        color: "common.ui1",
        size: 30,
    },
    panel: {
        css: css`
            position: fixed;
            left: 0;
            top: calc(20% + 42px);
            transition: all ease-in 0.3s;
            transform: translateX(-105%);
            margin-top: -4px;
            box-shadow: 0 0 0.625rem 0 rgba(102, 102, 102, 0.5);
            min-height: 100px;
            min-width: 300px;
            background: ${color("common.ui1")};

            .compactQuickOrder [class^="InventoryMessage"] {
                width: auto !important;
            }

            ${({ isFixedQuickOrderOpened }: any) => {
                if (isFixedQuickOrderOpened) {
                    return `
                        transform: translateX(0);
                    `;
                }
            }}
        `,
    },
};
